import { ForwardedRef, forwardRef } from 'react'
import clsx from 'clsx'

import { Icon } from 'Components/Icon/Icon'

import { Heading } from '../Heading/Heading'
import { AlertProps } from './Alert.types'

export const Alert = forwardRef(
  (props: AlertProps, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      children,
      className,
      iconLeft,
      iconRight,
      variant = 'info',
      title,
      ...restProps
    } = props

    const classNames = clsx(
      'Alert',
      `Alert-${variant}`,
      title && 'Alert-with_title',
      className,
    )

    return (
      <div className={classNames} role="alert" {...restProps} ref={ref}>
        {iconLeft && (
          <Icon
            className="Alert-icon Alert-icon-left"
            icon={iconLeft}
            size={16}
          />
        )}

        <div className="Alert-content">
          {title && (
            <div className="Alert-title">
              <Heading as={4} size={2}>
                {title}
              </Heading>

              {iconRight && (
                <Icon className="Alert-icon" icon={iconRight} size={16} />
              )}
            </div>
          )}

          {children}
        </div>

        {iconRight && !title && (
          <Icon className="Alert-icon" icon={iconRight} size={16} />
        )}
      </div>
    )
  },
)
